import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/theme.css';
import '../styles/WelcomePage.css';
import '../styles/OopsPage.css';

export type OopsReason =
  | 'client_not_found'
  | 'client_disabled'
  | 'page_not_found'
  | 'generic';

const KNOWN: OopsReason[] = [
  'client_not_found',
  'client_disabled',
  'page_not_found',
];

/** Legacy `missing_client_guid` is treated as `client_not_found` (same copy). */
function resolveReason(
  stateReason: unknown,
  queryReason: string | null
): OopsReason {
  if (stateReason === 'missing_client_guid' || queryReason === 'missing_client_guid') {
    return 'client_not_found';
  }
  if (
    typeof stateReason === 'string' &&
    KNOWN.includes(stateReason as OopsReason)
  ) {
    return stateReason as OopsReason;
  }
  if (queryReason && KNOWN.includes(queryReason as OopsReason)) {
    return queryReason as OopsReason;
  }
  return 'generic';
}

const OopsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const stateReason = (location.state as { reason?: OopsReason } | null)?.reason;
  const queryReason = searchParams.get('reason');
  const reason = resolveReason(stateReason, queryReason);

  const bodyKey =
    reason === 'client_not_found' || reason === 'client_disabled'
      ? 'oops.client_not_found'
      : reason === 'page_not_found'
        ? 'oops.pageNotFound'
        : 'oops.generic';

  return (
    <div className="welcome-page oops-page">
      <header className="welcome-header">
        <img
          src={`${process.env.PUBLIC_URL}/aspirion-logo.png`}
          alt={t('welcome.logoAlt')}
          className="welcome-logo"
        />
      </header>

      <div className="welcome-card oops-card">
        <div className="welcome-banner oops-banner" aria-hidden />
        <main className="welcome-content oops-content">
          <h1 className="welcome-heading">{t('oops.title')}</h1>
          <p className="welcome-text">{t(bodyKey)}</p>
        </main>
      </div>
    </div>
  );
};

export default OopsPage;
